/**
 * vue-tweezing v0.1.6
 * (c) 2018 Eduardo San Martin Morote <posva13@gmail.com>
 * @license MIT
 */

(function (global, factory) {
	typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports) :
	typeof define === 'function' && define.amd ? define(['exports'], factory) :
	(factory((global.VueTweezing = {})));
}(this, (function (exports) { 'use strict';

// collection of functions to create tweens
var tweeners = {};

var Tweezing = {
  props: {
    to: [Number, Object, Array],
    tween: {
      type: [String, Function],
      default: function () { return 'default'; },
    },
  },

  data: function data () {
    return {
      value: 0,
    }
  },

  created: function created () {
    // ensure the watcher of tween to be called first so
    // tweenFn exists in `to` watcher
    this.$options.watch.tween.call(this, this.tween);
    this.value = this.to;
    this.$options.watch.to.call(this, this.to);
  },

  render: function render (h) {
    var node = this.$scopedSlots.default(this.value);
    if (Array.isArray(node)) {
      // TODO dev error
      return node[0]
    }
    return node
  },

  methods: {
    ensureValue: function ensureValue (val) {
      var targetType = typeof val;
      var currentType = typeof this.value;
      if (targetType === currentType) {
        if (Array.isArray(val)) {
          this.value.length = val.length;
        }
        return
      }
      // set initial value to current value
      if (targetType === 'number') {
        this.value = val;
      } else if (Array.isArray(val)) {
        this.value = val.slice();
      } else if (targetType === 'object') {
        this.value = Object.keys(val).reduce(function (values, name) {
          values[name] = val[name];
          return values
        }, {});
      }
    },
  },

  watch: {
    tween: function tween (tween$1) {
      if (typeof tween$1 === 'function') {
        this.tweenFn = tween$1;
      } else {
        // TODO warning if not string or non-existant
        this.tweenFn = tweeners[tween$1];
      }
    },
    // TODO should probably be deep
    to: function to (to$1, old) {
      var this$1 = this;

      var type = typeof to$1;
      this.ensureValue(to$1);

      stopTweens(this.$tween);
      if (type === 'number') {
        this.$tween = this.tweenFn(this.value, to$1, Object.assign({}, {$setValue: function (v) {
            this$1.value = v;
          }},
          this.$attrs), this);
      } else if (Array.isArray(to$1)) {
        this.$tween = to$1.map(function (value, i) {
          return this$1.tweenFn(this$1.value[i] || 0, value, Object.assign({}, {$setValue: function (v) {
              this$1.value.splice(i, 1, v);
            }},
            this$1.$attrs))
        });
      } else if (type === 'object') {
        this.$tween = Object.keys(to$1).reduce(function (tweens, name) {
          tweens[name] = this$1.tweenFn(this$1.value[name], to$1[name], Object.assign({}, {$setValue: function (v) {
              this$1.value[name] = v;
            }},
            this$1.$attrs));
          return tweens
        }, Object.create(null));
      }
    },
  },

  // to use as a plugin
  install: function install (Vue, options) {
    if ( options === void 0 ) options = {};

    Vue.component(options.name || 'Tweezing', Tweezing);
    var defaultTweener = options.default;
    // could have used {name, default, ...options} but I don't really like
    // the way bubel polyfills it (even in es)
    delete options.name;
    delete options.default;
    var tweenerNames = Object.keys(options);
    tweenerNames.forEach(function (tweener) {
      tweeners[tweener] = options[tweener];
    });
    // Use the first one or anyone provided by the user
    tweeners.default = tweeners[defaultTweener || tweenerNames[0]];
  },
};

function stopTweens (tweens) {
  if (tweens) {
    // TODO use a better method
    // the prototype is null when using objects
    if (Array.isArray(tweens)) {
      tweens.forEach(function (tween) { return tween.stop(); });
    } else if (!Object.getPrototypeOf(tweens)) {
      // TODO not all tweens have a stop method
      for (var key in tweens) { tweens[key].stop(); }
    } else {
      tweens.stop();
    }
  }
}

// helper for tweezer.js
function tweezerHelper (Tweezer) {
  return function (start, end, opts) {
    var this$1 = this;

    // cancel previous tween
    var started;
    return new Tweezer(Object.assign({}, {start: start,
      end: end},
      opts)).on('tick', function (value) {
      if (!started) {
        started = true;
        this$1.$emit('start');
      }
      opts.$setValue(value);
    }).on('done', function () { return this$1.$emit('end'); })
      .begin()
  }
}

function tweenjsHelper (TWEEN) {
  return function (value, end, opts) {
    var this$1 = this;

    var container = { value: value };
    // cancel previous tween
    return new TWEEN.Tween(container)
      .to({ value: end }, opts.duration)
      .interpolation(opts.interpolation || TWEEN.Interpolation.Linear)
      .easing(opts.easing || TWEEN.Easing.Quadratic.Out)
      // TODO should probably emit the name of the property too
      // default could be the name if only one value is provided
      .onStart(function () { return this$1.$emit('start'); })
      .onUpdate(function () {
        opts.$setValue(container.value);
      })
      .onComplete(function () { return this$1.$emit('end'); })
      .start()
  }
}

exports.Tweezing = Tweezing;
exports.tweezerHelper = tweezerHelper;
exports.tweenjsHelper = tweenjsHelper;

Object.defineProperty(exports, '__esModule', { value: true });

})));



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-tweezing/dist/vue-tweezing.js
// module id = 379
// module chunks = 0 1